<template>
  <div>
    <h2 :id="data.label" class="body-1-bold mb-0">
      {{ data.label }}
    </h2>
    <table
      :aria-labelledby="data.label"
      aria-readonly="true"
      cellpadding="0"
      cellspacing="0"
      class="w-full py-12"
    >
      <tbody>
        <!-- hidden, only used for SEO purpose  -->
        <tr class="absolute h-1 w-1 overflow-hidden">
          <td></td>

          <th
            v-for="model in models"
            :key="model"
            role="presentation"
            scope="col"
          >
            {{ model }}
          </th>
        </tr>

        <Row v-for="row in data.rows" :key="row.label" v-bind="row" />

        <tr v-if="data.helperText">
          <td>
            <p
              class="text-static-default-low body-2 mt-24 whitespace-normal break-words"
            >
              {{ data.helperText }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import Row from './Row.vue'
import type { ModelsComparisonTable } from './models'

defineProps<{ data: ModelsComparisonTable; models: string[] }>()
</script>
